<template>
    <td class="table-url-cell">
        <a v-if="actualValue" :href="href" @click.stop.prevent="open" target="_blank"> {{actualValue}}
            <ux-icon right icon="fa-external-link" /></a>
    </td>
</template>
<script>
import TableCellMixin from './TableCellMixin.js';

export default {
    mixins: [TableCellMixin],
    methods: {
        open() {
            window.open(this.href);
        }
    },
    computed: {
        actualValue() {
            return String(this.value || '').trim();
        },
        href() {
            let url = this.actualValue;

            // Check if the URL starts with 'http://' or 'https://'
            if (!/^https?:\/\//i.test(url)) {
                // Assume HTTPS if no protocol is specified
                return 'https://' + url;
            }
            // If the URL already starts with 'http://' or 'https://', return it as is
            return url;

        }
    }
}
</script>
<style scoped lang="scss">
td {
    white-space: nowrap;

    a {
        font-size: 0.8em;
        text-decoration: none;
        color: inherit;

        &:hover {
            opacity: 0.5;
        }
    }
}
</style>